import React from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo/srvLogo.png";
import "./SidebarMob.css";

const SidebarMob = () => {
  const navigate = useNavigate(); // <-- Initialize
  return (
    <div className="sidebar-menu-wrapper overflow-y-auto scroll-sm d-flex flex-column flex-grow-1">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          fontSize: "30px",
          backgroundColor: "white",
          paddingTop: "10px",
          paddingRight: "20px",
        }}
      >
        <i
          class="ph ph-caret-left"
          onClick={() => navigate(-1)}
          style={{
            backgroundColor: "#ECF2FE",
            color: "#333",
            borderRadius: "50%",
            padding: "5px",
          }}
        ></i>
      </div>
      <Link
        to="/admin-dashboard2"
        className="sidebar__logo text-center p-20 position-sticky inset-block-start-0 bg-white w-100 z-1 pb-10"
      >
        <img src={logo} alt="Logo" width="100px" />
      </Link>

      <div
        className="p-20 pt-10 flex-grow-1"
        style={{ backgroundColor: "white", marginBottom: "20px" }}
      >
        <ul className="sidebar-menu">
          {/* Dashboard Section */}
          <li className="sidebar-menu__item">
            <Link  to="/admin-dashboard2" className="sidebar-menu__link">
              <span className="icon me-3">
                <i className="ph ph-squares-four"></i>
              </span>
              <span className="text">Dashboard</span>
            </Link>
          </li>

          <li className="sidebar-menu__item">
            <Link to="/settings" className="sidebar-menu__link">
              <span className="icon me-3">
                <i class="ph ph-gear"></i>
              </span>
              <span className="text">Academics</span>
            </Link>
          </li>

          {/* Question Paper Section
            <li className="sidebar-menu__item has-dropdown">
              <Link to="#" className="sidebar-menu__link">
               <span className="icon me-3">

                  <i class="ph ph-article"></i>
                </span>
                <span className="text">Question Paper</span>
              </Link>

             
            </li> */}

          {/* Settings Section */}
          {/* <li className="sidebar-menu__item has-dropdown">
              <Link to="#" className="sidebar-menu__link">
               <span className="icon me-3">

                  <i class="ph ph-gear"></i>
                </span>
                <span className="text">Settings</span>
              </Link>
              <ul className="sidebar-submenu">
                <li className="sidebar-submenu__item active">
                  <Link to="/modules" className="sidebar-submenu__link">
                    Classes
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/course" className="sidebar-submenu__link">
                    Course
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/subject" className="sidebar-submenu__link">
                    Subject
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/chapter" className="sidebar-submenu__link">
                    Chapter
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/topic" className="sidebar-submenu__link">
                    Topic
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/level" className="sidebar-submenu__link">
                    Level
                  </Link>
                </li>
              </ul>
            </li> */}

          {/* Questions Section */}
          <li className="sidebar-menu__item ">
            <Link to="/questions" className="sidebar-menu__link">
              <span className="icon me-3">
                <i class="ph ph-question"></i>
              </span>
              <span className="text">Question Bank</span>
            </Link>
            {/* <ul className="sidebar-submenu">
                <li className="sidebar-submenu__item">
                  <Link to="/add-question" className="sidebar-submenu__link">
                    Add Question
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/import-question" className="sidebar-submenu__link">
                    Import Question
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link
                    to="/question-details"
                    className="sidebar-submenu__link"
                  >
                    Question Details
                  </Link>
                </li>
              </ul> */}
          </li>

          {/* Paper Section */}
          <li className="sidebar-menu__item ">
            <Link to="/paper-details" className="sidebar-menu__link">
              <span className="icon me-3">
                <i class="ph ph-scroll"></i>
              </span>
              <span className="text">Question Paper</span>
            </Link>
            {/* <ul className="sidebar-submenu">
                <li className="sidebar-submenu__item">
                  <Link to="/paper-details" className="sidebar-submenu__link">
                    Paper Details
                  </Link>
                  
                </li>
                <li  className="sidebar-submenu__item">
                <Link to="/template" className="sidebar-submenu__link">
                    Create Template
                  </Link>
                </li>
                <li  className="sidebar-submenu__item">
                <Link to="/template-details" className="sidebar-submenu__link">
                    Template Details
                  </Link>
                </li>
               
              </ul> */}
          </li>

          <li className="sidebar-menu__item">
            <Link to="/template-details" className="sidebar-menu__link">
              <span className="icon me-3">
                <i class="ph ph-list-dashes"></i>
              </span>
              <span className="text">Template</span>
            </Link>
          </li>

          {/* Students Section */}
          {/* <li className="sidebar-menu__item ">
            <Link to="/student-details" className="sidebar-menu__link">
              <span className="icon me-3">
                <i class="ph ph-identification-card"></i>
              </span>
              <span className="text">Students</span>
            </Link>
          
          </li> */}

          {/* Staff Section */}
          <li className="sidebar-menu__item">
            <Link to="/staff-role" className="sidebar-menu__link">
              <span className="icon me-3">
                <i class="ph ph-users"></i>
              </span>
              <span className="text">Staff</span>
            </Link>
            {/* <ul className="sidebar-submenu">
                <li className="sidebar-submenu__item">
                  <Link to="/staff-details" className="sidebar-submenu__link">
                    Staff Details
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/role" className="sidebar-submenu__link">
                   Role
                  </Link>
                </li>
              </ul> */}
          </li>

           <li className="sidebar-menu__item">
            <Link to="/staff-role" className="sidebar-menu__link">
              <span className="icon me-3">
                <i class="ph ph-medal"></i>
              </span>
              <span className="text">Leaderboard</span>
            </Link>
            </li>

          {/* Account Settings */}
          {/* <li className="sidebar-menu__item has-dropdown">
              <Link to="#" className="sidebar-menu__link">
                <span className="icon">
                <i class="ph ph-shield-checkered"></i>
                </span>
                <span className="text">Authentication</span>
              </Link>
              <ul className="sidebar-submenu">
                <li className="sidebar-submenu__item">
                  <Link to="/login" className="sidebar-submenu__link">
                    Login
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/signup" className="sidebar-submenu__link">
                    Sign Up
                  </Link>
                </li>
                <li className="sidebar-submenu__item">
                  <Link to="/forgot-password" className="sidebar-submenu__link">
                    Forgot Password 
                  </Link>
                </li>
              </ul>
            </li> */}
          {/* Authentication Section */}
        </ul>
      </div>
      {/* Logout Button at the Bottom */}
      {/* <div className="p-3 mb-15">
          <button
            className="d-flex align-items-center justify-content-center text-danger fw-semibold w-100"
            onClick={handleLogout}
            style={{
              borderRadius: "40px",
              padding: "10px",
              backgroundColor: "#ECF2FE",
              transition: "all 0.3s ease-in-out",
            }}
          >
            <i className="ph ph-sign-out" style={{ fontSize: "20px" }}></i> Log
            Out
          </button>
        </div> */}
    </div>
  );
};

export default SidebarMob;
